import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import loadable from "@loadable/component"

//assets
import ReversedLogo from "../../assets/reversedLogo.svg"

//styles
import * as Styled from "./startseite.styles"
import Karriere from "./karriere/karriere.component"

//components
const KontaktMap = loadable(() => import("../kontakt/map/map.component"))
const Quote = loadable(() => import("../quote/quote.component"))
const Nachricht = loadable(() => import("../nachricht/nachricht.component"))
const LeistungenKarten = loadable(() =>
  import("./leistungen-karten/leistungen-karten.component")
)
const Aktuelles = loadable(() =>
  import("./aktuelles/aktuelles-container.component")
)
const Leistungen = loadable(() => import("./leistungen/leistungen.component"))
const Versprechen = loadable(() =>
  import("./versprechen/versprechen.component")
)
const Team = loadable(() => import("./team/team.component"))

const query = graphql`
  {
    startIllustrationen1: file(
      relativePath: { regex: "/startIllustrationen1.png$/" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    startIllustrationen2: file(
      relativePath: { regex: "/startIllustrationen2.png$/" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`

const Startseite = () => {
  //Images
  const data = useStaticQuery(query)
  const startIllustrationen1 = getImage(data.startIllustrationen1)
  const startIllustrationen2 = getImage(data.startIllustrationen2)

  return (
    <Styled.Main>
      <Styled.Einleitung>
        <Styled.Background>
          <div className="icon__container">
            <GatsbyImage image={startIllustrationen1} alt="" />
          </div>
          <div className="icon__container">
            <GatsbyImage image={startIllustrationen2} alt="" />
          </div>
        </Styled.Background>
        <div className="logo">
          <ReversedLogo />
        </div>
        <Styled.Überschrift>
          <h1>
            Pflege & Betreuung <br />
            für selbstbestimmte Menschen!
          </h1>
          <div>
            <span>kompetent</span>
            <span>herzlich</span>
            <span>verbindlich</span>
          </div>
        </Styled.Überschrift>
        <Styled.EinleitungsText>
          <p>
            <b>SPÄTSOMMER</b> bietet Ihnen für Ihren individuellen
            Betreuungsbedarf das passende Angebot. Der{" "}
            <b>ambulante Pflegedienst</b> unterstützt Sie in Ihrem eigenen
            Zuhause – für ein Maximum an Wohlbefinden und Selbstbestimmung. In
            unserer <b>Wohngemeinschaft</b> betreuen wir Menschen mit
            eingeschränkter Alltagskompetenz – rund um die Uhr, herzlich und
            fachkompetent. Unsere geplante <b>Tagesstätte</b> bietet Ihnen
            altersgerechte Aktivitäten, Wohlfühlambiente, Kurzweiligkeit und
            lebendigen Kontakt zu anderen Gästen. Wir beraten Sie gerne!
          </p>
        </Styled.EinleitungsText>
        <LeistungenKarten />
        <Aktuelles />
      </Styled.Einleitung>
      <Leistungen />
      <Versprechen />
      <Team />
      <Karriere />
      <Styled.Kontakt>
        <h2>Kontaktieren Sie uns!</h2>
        <KontaktMap />
      </Styled.Kontakt>
      <Nachricht>
        Haben Sie Interesse bekommen die Einrichtung auch einmal persönlich zu
        besuchen?
      </Nachricht>
    </Styled.Main>
  )
}

export default Startseite
